import { render } from "./DemoList.vue?vue&type=template&id=0681f797"
const script = {}

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__